export default "__VITE_ASSET__D8sZ4A0e__"